module.exports = __webpack_public_path__ + "static/assets/0fe69dd25d6d6eef33e465719f3a71d5.png";